export const BANNER_BUTTON_HEIGHT = {
  NORMAL: 48,
}
